import React, { PureComponent } from 'react';

import { BuildStatusCard } from 'src/components/build-status-card';
import { ResizeProps, SidebarContent, Cards } from 'src/components/sidebar';
import { ConnectSourceWebCards } from 'src/connect/web-cards';
import { LazyForgeRepoCodeOverviewCards } from 'src/forge/repo-code-overview-cards/lazy-repo-code-overview-cards';
import CompassBannerWithFF from 'src/sections/dashboard/overview/components/compass-banner';
import Sidebar from 'src/sections/global/containers/sidebar';

import SidebarKeyboardShortcuts from '../../../components/sidebar-keyboard-shortcuts';
import BuildStatusProvider from '../containers/build-status-provider';

import { CompassCard } from './compass/card';
import NewUserCard from './new-user-card';
import SourceDetailsCard from './source-details-card';

type SourceSidebarProps = {
  expandedWidth: number;
  isCollapsed?: boolean;
  isNewUser: boolean;
  onResize: (props: ResizeProps) => void;
  toggleSidebar: () => void;
  isLoggedIn?: boolean;
};

class SourceSidebar extends PureComponent<SourceSidebarProps> {
  static defaultProps = {
    isCollapsed: false,
    isLoggedIn: false,
  };

  render() {
    const collapsedContent: SidebarContent[] = [];
    const expandedContent: SidebarContent[] = [];
    if (this.props.isNewUser) {
      collapsedContent.push({
        type: Cards.NewUser,
        content: <NewUserCard isCollapsed />,
      });
      expandedContent.push({ type: Cards.NewUser, content: <NewUserCard /> });
    }

    collapsedContent.push(
      {
        type: Cards.SourceDetails,
        content: <SourceDetailsCard isCollapsed />,
      },
      { type: Cards.BuildStatus, content: <BuildStatusCard isCollapsed /> }
    );

    expandedContent.push(
      { type: Cards.CompassBanner, content: <CompassBannerWithFF isCard /> },
      {
        type: Cards.SourceDetails,
        content: <SourceDetailsCard />,
      },
      { type: Cards.BuildStatus, content: <BuildStatusCard /> }
    );
    if (this.props.isLoggedIn) {
      collapsedContent.push({
        type: Cards.CompassCard,
        content: <CompassCard isCollapsed isLoggedIn={this.props.isLoggedIn} />,
      });
      expandedContent.push({
        type: Cards.CompassCard,
        content: <CompassCard isLoggedIn={this.props.isLoggedIn} />,
      });
    }
    collapsedContent.push({
      type: Cards.ConnectSource,
      content: <ConnectSourceWebCards isCollapsed />,
    });
    expandedContent.push(
      { type: Cards.ConnectSource, content: <ConnectSourceWebCards /> },
      {
        type: Cards.ForgeRepoCodeOverviewCard,
        content: <LazyForgeRepoCodeOverviewCards />,
      }
    );

    return (
      <SidebarKeyboardShortcuts
        sidebarType="source"
        toggleSidebar={this.props.toggleSidebar}
      >
        <BuildStatusProvider>
          <Sidebar
            collapsedContent={collapsedContent}
            expandedContent={expandedContent}
            isCollapsed={!!this.props.isCollapsed}
            onResize={this.props.onResize}
            expandedWidth={this.props.expandedWidth}
          />
        </BuildStatusProvider>
      </SidebarKeyboardShortcuts>
    );
  }
}

export default SourceSidebar;
